import { render, staticRenderFns } from "./ProductsIndex.vue?vue&type=template&id=4c6bb79a&lang=pug&"
import script from "./ProductsIndex.vue?vue&type=script&lang=js&"
export * from "./ProductsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports